import React from 'react';
import { Button, Text, open } from './styles';

export default ({
	whenOpened,
	whenClosed,
	onClick,
	opened
}) => {
	return <Button onClick={onClick}>
		<Text className={opened && open}>{opened ? whenOpened : whenClosed}</Text>
	</Button>;
}
